
import { email, minLength, required } from 'vuelidate/lib/validators';
import { parseUtmLabels } from '~/helpers/formSend';
import errorParseNetwork from '~/helpers/errorParseNetwork';

export default {
  data: function () {
    return {
      form: {
        name: '',
        phone: '',
        message: '',
      },
      accept: false,
    };
  },

  validations: function () {
    const form = {
      phone: {
        required,
        minLength: minLength(18),
      },
    };

    return {
      form,
    };
  },

  computed: {
    isOpen: function () {
      return Object.keys(this.$store.state['fast-buy']?.product || {}).length > 0;
    },

    product: function () {
      return this.$store.state['fast-buy']?.product || {};
    },
    productImage: function () {
      return String(this.product?.imageId || '');
    },
    productName: function () {
      return this.product?.name || '';
    },
    productUrl: function () {
      console.log('url',this.product?.url)
      return this.product?.url || '';
    },

    errorPhone: function () {
      const error = this.$v?.form?.phone;
      if (!error?.$invalid || !error?.$dirty) {
        return null;
      }

      if (!error.required) {
        return 'Обязательно к заполнению';
      }
      if (!error.minLength) {
        return 'Неправильный формат ввода';
      }

      return null;
    },
  },

  methods: {
    submitForm: async function () {
      if (!this.accept) {
        return;
      }

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$store.commit('loading/setLoading', true);

      const utmLabels = parseUtmLabels();
      this.form.message = ' ';
      const message = [
        Boolean(this.form.message) && `<br><b>Код товара</b>: ${this.product.code}<br><b>Товар</b>: <a href="${this.product.url}" target="_blank">${this.product.name}</a><br><b>Комментарий пользователя</b>: ${this.form.message}`,
        Boolean(this.formMessage) && `<b>Дополнительный комментарий</b>: ${this.formMessage}`,
      ].filter((t) => !!t).join('</br>');

      const body = {
        type: 'Быстрый заказ',
        name: this.form.name || 'Гость',
        phone: (this.form?.phone || '').replace(/[^\d]/g, ''),
        message: message,
        url: window.location.href,
        source: '',
        title: '',
        additional_data: '',
      };
      if (utmLabels) {
        body.additional_data = {
          ...body.additional_data,
          ...utmLabels,
        };
      }

      const response = await this.$api.agent.transport.post('/form/send', body).then((res) => res.data).catch((err) => ({ error: errorParseNetwork(err.response) }));
      if (response.error) {
        this.$toast.error(response.error);
        this.$store.commit('loading/setLoading', false);
        return;
      }

      this.closeForm();

      this.form = {
        name: '',
        email: '',
        phone: '',
        message: '',
      };
      this.$v.$reset();
      this.$store.commit('loading/setLoading', false);
      this.$toast.success('Ваша заявка успешно отправлена');

      this.$yandexMetrika.reachGoal('Быстрый заказ');
    },
    closeForm: function () {
      this.$store.commit('fast-buy/close');
      this.$v.$reset();
      this.form = {
        name: '',
        email: '',
        phone: '',
        message: '',
      };
      this.$v.$reset();
    },
  },
};
